import React from "react"

import BssoPermissions from "components/LM/Bsso/Permissions";
import VoiceRecoveryResults from "components/LM/Voice/Recovery/Results";

function RecoveryResultsPage(props) {
	return (
		<BssoPermissions permissions={["social_recovery"]} behaviour="error">
			<VoiceRecoveryResults {...props}/>
		</BssoPermissions>
	)
}

export default RecoveryResultsPage;
